export enum DataExchangeKind {
    JPK_FA = 'JPK_FA',
    JPK_VAT = 'JPK_VAT',
    Epp = 'Epp',
    NexoOnline = 'NexoOnline',
    PackageOfDocuments = 'PackageOfDocuments'
}

export enum JpkVatSubkind {
    JPK_V7K = 'JPK_V7K',
    JPK_V7M = 'JPK_V7M',
}

export enum PackageOfDocumentsSubkind {
    SinglePdf = 'PackageOfDocuments_SinglePdf',
    CompressedDocuments = 'PackageOfDocuments_CompressedDocuments'
}
